import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { type InvoiceAgeReport } from '../models/invoice-age-report';
import { type InvoiceSubmissionResult } from '../models/invoice-submission';
import { type SoPendingBillingResult } from '../models/so-pending-billing';

@Injectable({
	providedIn: 'root'
})
export class ReportHttpService {
	private httpClient = inject<HttpClient>(HttpClient);
	private baseUrl = environment.portalApi.uri + '/report';

	public getInvoiceAgingReport(): Observable<InvoiceAgeReport[]> {
		return this.httpClient.get<InvoiceAgeReport[]>(
			this.baseUrl + '/invoice-aging'
		);
	}

	//gets the invoice submissions for the invoice metrics export
	public getInvoiceSubmissions(): Observable<InvoiceSubmissionResult[]> {
		return this.httpClient.get<InvoiceSubmissionResult[]>(
			this.baseUrl + '/invoice-submissions'
		);
	}

	public getSoPendingBillingReport(): Observable<SoPendingBillingResult[]> {
		return this.httpClient.get<SoPendingBillingResult[]>(
			this.baseUrl + '/so-pending-billing'
		);
	}
}
